import type { SVGProps } from 'react';

const SignModalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="edit-04">
      <path
        id="Icon"
        d="M21 17.9963L19.9999 19.0904C19.4695 19.6705 18.7501 19.9963 18.0001 19.9963C17.2501 19.9963 16.5308 19.6705 16.0004 19.0904C15.4692 18.5114 14.75 18.1864 14.0002 18.1864C13.2504 18.1864 12.5311 18.5114 12 19.0904M3 19.9963H4.67454C5.16372 19.9963 5.40832 19.9963 5.63849 19.9411C5.84256 19.8921 6.03765 19.8113 6.2166 19.7016C6.41843 19.5779 6.59138 19.405 6.93729 19.0591L19.5 6.49632C20.3285 5.66789 20.3285 4.32475 19.5 3.49632C18.6716 2.66789 17.3285 2.66789 16.5 3.49632L3.93726 16.0591C3.59136 16.405 3.4184 16.5779 3.29472 16.7797C3.18506 16.9587 3.10425 17.1538 3.05526 17.3579C3 17.588 3 17.8326 3 18.3218V19.9963Z"
        stroke="#4338CA"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
  </svg>
);

export default SignModalIcon;
